import React, { useState, useRef } from "react";
import Typography from '@mui/joy/Typography';
import Box from '@mui/joy/Box';
// import axios from "axios";
import { Modal, Card, ModalDialog, CardContent } from '@mui/joy';
import request from '../helpers/request'
function renderValue(value) {
	if (Array.isArray(value)) {
		return (
			<ul style={{ paddingLeft: "20px", margin: 0 }}>
				{value.map((item, i) => (
					<li key={i}>{renderValue(item)}</li>
				))}
			</ul>
		);
	} else if (typeof value === 'object' && value !== null) {
		return (
			<table style={{ border: "1px solid #ccc", borderCollapse: "collapse", margin: "5px 0" }}>
				<tbody>
					{Object.entries(value).map(([k, v]) => (
						<tr key={k}>
							<td style={{ border: "1px solid #ccc", padding: "5px", verticalAlign: "top" }}>{k}</td>
							<td style={{ border: "1px solid #ccc", padding: "5px" }}>{renderValue(v)}</td>
						</tr>
					))}
				</tbody>
			</table>
		);
	} else {
		return <span>{String(value)}</span>;
	}
}
function Table({ comparison }) {
	return (
		<table
			border="1"
			style={{
				borderCollapse: 'collapse',
				textAlign: "left",
				width: "80vw",
				overflow: "auto"
			}}
		>
			<thead>
				<tr>
					<th style={{ width: '10%', padding: "5px" }}>Key</th>
					<th style={{ width: '90%', padding: "5px" }}>Value</th>
				</tr>
			</thead>
			<tbody>
				{comparison.map((item, idx) => {
					const [key, value] = Object.entries(item)[0];
					return (
						<tr key={idx}>
							<td style={{ verticalAlign: 'top', padding: "5px" }}>{key}</td>
							<td style={{ padding: "5px" }}>{renderValue(value)}</td>
						</tr>
					);
				})}
			</tbody>
		</table>
	);
}
const ImagePDFUploader = () => {
	const [uploads, setUploads] = useState([]);
	const [rectangles, setRectangles] = useState({});
	const [drawing, setDrawing] = useState(false);
	const [drawingIndex, setDrawingIndex] = useState(null);
	const [isLoading, setIsLoading] = useState(false)
	const canvasRefs = useRef([]);
	const [comparison, setComparison] = useState([])
	const submit = async () => {
		setIsLoading(true)
		const scaledRectangles = uploads.map((file, index) => {
			const scaleX = file.naturalWidth / canvasRefs.current[index].offsetWidth;
			const scaleY = file.naturalHeight / canvasRefs.current[index].offsetHeight;
			return rectangles[index]?.map((rect) => ({
				startX: rect.startX * scaleX,
				startY: rect.startY * scaleY,
				endX: rect.endX * scaleX,
				endY: rect.endY * scaleY,
				name: rect.name
			}));
		});
		const formData = new FormData();
		formData.append("image_1", uploads[0].file); // Proper File object
		formData.append("image_2", uploads[1].file);
		formData.append("coords_1", JSON.stringify(scaledRectangles[0])); // Proper JSON strings
		formData.append("coords_2", JSON.stringify(scaledRectangles[1]));
		try {
			const response = await request.post(
				"/api/v1/services/comparison_tool/compare",
				formData,
				{
					headers: {
						"Content-Type": "multipart/form-data",
					},
				}
			);
			// Developement only
			// const response = await axios.post(
			// 	"http://localhost:8002/compare",
			// 	formData,
			// 	{
			// 		headers: {
			// 			"Content-Type": "multipart/form-data",
			// 		},
			// 	}
			// )
			setComparison(response.data)
			setIsLoading(false)
		} catch (error) {
			console.error("Upload failed:", error);
			setIsLoading(false)
		}
	}
	const handleFileChange = async (e) => {
		const files = Array.from(e.target.files)
		files.forEach(async file => {
			let contents = ""
			contents = URL.createObjectURL(file)
			if (file.type.includes("pdf")) {
				contents = await fileToBase64(file)
			}
			const newFile = {
				name: file.name,
				file: file,
				url: contents,
			}
			setUploads((prev) => [...prev, ...[newFile]]);
		});
	};
	const startDrawing = (e, index) => {
		if (drawing) return; // Prevent starting a new rectangle mid-draw
		const rect = canvasRefs.current[index].getBoundingClientRect();
		const startX = e.clientX - rect.left;
		const startY = e.clientY - rect.top;
		const name = rectangles[index]?.length || 0
		setRectangles((prev) => ({
			...prev,
			[index]: [...(prev[index] || []), { startX, startY, endX: startX, endY: startY, file: index, name: name }],
		}));
		setDrawing(true);
		setDrawingIndex(index); // Track the image where drawing is happening
	};
	const finishDrawing = () => {
		setDrawing(false);
		setDrawingIndex(null); // Reset drawing index
	};
	const handleMouseMove = (e) => {
		if (!drawing || drawingIndex === null) return;
		const rect = canvasRefs.current[drawingIndex].getBoundingClientRect();
		const endX = e.clientX - rect.left;
		const endY = e.clientY - rect.top;
		setRectangles((prev) => {
			const updatedRects = [...(prev[drawingIndex] || [])];
			updatedRects[updatedRects.length - 1] = {
				...updatedRects[updatedRects.length - 1],
				endX,
				endY,
			};
			return { ...prev, [drawingIndex]: updatedRects };
		});
	};
	const handleRemoveRectangle = (imageIndex, rectIndex) => {
		setRectangles((prev) => {
			const updatedRects = [...prev[imageIndex]];
			updatedRects.splice(rectIndex, 1);
			return { ...prev, [imageIndex]: updatedRects };
		});
	};
	const getRectStyle = (rect) => {
		const x = Math.min(rect.startX, rect.endX);
		const y = Math.min(rect.startY, rect.endY);
		const width = Math.abs(rect.endX - rect.startX);
		const height = Math.abs(rect.endY - rect.startY);
		return {
			position: "absolute",
			top: y,
			left: x,
			width,
			height,
			border: "2px solid red",
			backgroundColor: "rgba(255, 0, 0, 0.2)",
			pointerEvents: "none",
		};
	};
	const fileToBase64 = (file) =>
		new Promise((resolve, reject) => {
			const reader = new FileReader();
			reader.readAsDataURL(file);
			reader.onload = () => resolve(reader.result);
			reader.onerror = (error) => reject(error);
		});
	return (
		<>
			<Box
				sx={{
					display: 'flex',
					mb: 1,
					gap: 1,
					flexDirection: { xs: 'column', sm: 'row' },
					alignItems: { xs: 'start', sm: 'center' },
					flexWrap: 'wrap',
					justifyContent: 'space-between'
				}}
			>
				<Typography level="h2" component="h1">
					Comparison
				</Typography>
				<div>
					<input
						type="file"
						accept=".pdf, .png, .jpg, .jpeg, /image"
						disabled={uploads.length === 2}
						multiple
						onChange={handleFileChange}
					/>
					<button
						style={{
							marginLeft: "2rem"
						}}
						disabled={isLoading || uploads.length !== 2}
						onClick={submit}
					>
						Process
					</button>
				</div>
			</Box>
			<div
				style={{
					height: "80%",
					width: "100%",
					display: "flex",
					alignItems: "center",
					justifyContent: "flex-start",
					flexDirection: "column",
				}}
			>
				<div
					style={{
						display: "flex",
						alignItems: "flex-start",
						justifyContent: "flex-start",
						gap: "0.5%",
						width: "100%",
					}}
				>
					{uploads.map((file, index) => (
						<div
							key={index}
							style={{
								position: "relative",
								width: "50%"
							}}
						>
							<img
								src={file.url}
								alt={file.name}
								style={{
									display: "block",
									width: "100%"
								}}
								onMouseDown={(e) => startDrawing(e, index)}
								onMouseUp={finishDrawing}
								onMouseMove={handleMouseMove}
								ref={(el) => {
									canvasRefs.current[index] = el;
									if (el) {
										// Set the natural dimensions of the image
										uploads[index].naturalWidth = el.naturalWidth;
										uploads[index].naturalHeight = el.naturalHeight;
									}
								}}
							/>
							{rectangles[index]?.map((rect, rectIndex) => (
								<div key={rectIndex}>
									<div style={getRectStyle(rect)}>
										<div
											style={{
												position: "absolute",
												bottom: -15,
												left: 0,
												backgroundColor: "rgba(0, 0, 0, 0.7)",
												color: "white",
												padding: "2px 5px",
												fontSize: "12px",
												borderRadius: "3px",
											}}
										>
											{rect.name}
										</div>
									</div>
									<button
										style={{
											position: "absolute",
											top: Math.min(rect.startY, rect.endY) - 10,
											left: Math.min(rect.startX, rect.endX) - 10,
											background: "red",
											color: "white",
											border: "none",
											borderRadius: "50%",
											width: "20px",
											height: "20px",
											cursor: "pointer",
										}}
										onClick={() => handleRemoveRectangle(index, rectIndex)}
									>
										X
									</button>
								</div>
							))}
						</div>
					))}
				</div>
				<Modal
					open={comparison.length > 0}
					onClose={() => setComparison([])}
					style={{ zIndex: "10000" }}
				>
					<ModalDialog>
						<Card
							style={{
								overflow: "auto",
								height: "70vh"
							}}
						>
							<CardContent>
								<Typography level='h4'>
									Comparison output
								</Typography>
								<Table comparison={comparison} />
							</CardContent>
						</Card>
					</ModalDialog>
				</Modal>
			</div>
		</>
	);
};
const Comparison = () => {
	return (
		<Box component="main"
			className="MainContent"
			sx={{
				flex: 1,
				display: 'flex',
				flexDirection: 'column',
				minWidth: 0,
				gap: 1,
				overflowY: 'auto',
			}}>
			{/* <Box sx={{ display: 'flex', alignItems: 'center' }}>
					<Breadcrumbs
						size="sm"
						aria-label="breadcrumbs"
						separator={<ChevronRightRoundedIcon fontSize="sm" />}
						sx={{ pl: 0 }}>
						<Link
							underline="none"
							color="neutral"
							href="#some-link"
							aria-label="Home">
						</Link>
					</Breadcrumbs>
				</Box> */}
			<ImagePDFUploader />
		</Box>
	)
}
export default Comparison
